import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import {inject} from '@angular/core';
import {SnackBarService} from '../snack-bar-service';
import {Router} from "@angular/router";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const snackbarService = inject(SnackBarService);
    const router: Router = inject(Router);
  req = req.clone({
    withCredentials: true
  });
  return next(req).pipe(catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          // Handle HTTP errors
          if (err && err.status === 401) {
            // handle 403 errors
           // router.navigateByUrl('admin/login').then();
             // console.log('url', req.url);
              if (req.url !== '/api/user.json' && req.url !== '/api/user/login.json') {
                 /* snackbarService.showMessage({
                      message: 'view.not.allowed',
                      success:false,
                      action: 'login'
                  });*/
                  /*userStateService.user = null;
                  uploadStateService.mode = 'inactive';
                  assetStateService.assetUuidFromQueryParam = null;*/
                  router.navigate(['/login'], {queryParams: {doReload: 'true,'}}).then();
              }

          } else if (err && err.status === 403) {
              snackbarService.showMessage({
                  message: 'view.not.allowed',
                  success:false
              });
          } else if (err && err.status === 404) {
              snackbarService.showMessage({
                  message: 'view.not.found',
                  success:false
              });
          }
        } else {
          // Handle non-HTTP errors
         // console.log('An error occurred:', err);
        }
        if (err && err.error) {
          const message = err.error.error;
          // console.log('error-message ', message);
          return throwError(message);
        }
        // Re-throw the error to propagate it further
        return throwError(err);
      })
  );
};
